import BaseComponent from '../BaseComponent';
import { ClassNames } from '../../utils/dom/css-classes';
import SelectorEngine from '../../utils/dom/selector-engine';

const NAME = 'ExitButton';

export default class ExitButton extends BaseComponent {
	static get NAME() {
		return NAME;
	}

	constructor(element, config) {
		super(element);
		if (this._element) {
			this.classPrefix = config.classPrefix;
			this.buttonLabel = config.buttonLabel || 'Exit'
			this.exitButtonClasses = config.exitButtonClasses || '';
		}
	}

	markup() {
		return `
			<div class="u-flex u-align-center" style="flex-direction:row">				
				<button class="${this.classPrefix}__form-exit-button lta-navigational-btn ${this.exitButtonClasses}" aria-label="Exit">
					<span class="lta-navigational-btn__text u-fw-bold u-body2">
						${this.buttonLabel}
					</span>	  		
					<svg class="lta-icon js-lta-text-input--btn-icon" width="1em" height="1em" fill="currentColor">
						<use xlink:href="/static/images/icons/lta-icons.svg#closev2"></use>
					</svg>
				</button>
		  	</div>
		`;
	}

	show() {
		const exitButton = SelectorEngine.findOne(`.${this.classPrefix}__form-exit-button`, this._element);
		exitButton?.classList?.remove(ClassNames.Hidden);
	}

	hide() {
		const exitButton = SelectorEngine.findOne(`.${this.classPrefix}__form-exit-button`, this._element);
		exitButton?.classList?.add(ClassNames.Hidden);
	}
}